import { useState, useEffect } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { GridColDef, GridValueGetterParams } from '@mui/x-data-grid';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import axios from "axios";
import { useForm, Resolver, Controller, SubmitHandler } from "react-hook-form";
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import SmartphoneIcon from '@mui/icons-material/Smartphone';
import EmailIcon from '@mui/icons-material/Email';
import Link from '@mui/material/Link';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { alpha, styled } from '@mui/material/styles';
import { DataGrid, gridClasses } from '@mui/x-data-grid';
import ConfirmDialog, { confirmDialog } from "../../components/ConfirmDialog";
import { setApplicationValues, setPageTitle } from "../../slices/applicationSlice";
import { IApplication } from "../../interfaces/IApplication";
import { useAppSelector, useAppDispatch } from "../../hooks";
import POIcon from '@mui/icons-material/ReceiptLong';
import ChemicalIcon from '@mui/icons-material/FormatColorFill';
import { IPurchaseOrderDetail, IPurchaseOrderDetails } from "../../interfaces/PurchaseOrder/IPurchaseOrderDetail";
import { useNavigate } from "react-router-dom";
import ActionButton from "../../components/ActionButton";
import ActionMenu from "../../components/ActionMenu";


const handleSubmitD = () => console.log('Okay')

const ODD_OPACITY = 0.2;

const StripedDataGrid = styled(DataGrid)(({ theme }) => ({
  [`& .${gridClasses.row}.even`]: {
    backgroundColor: theme.palette.grey[300],
    '&:hover, &.Mui-hovered': {
      backgroundColor: alpha(theme.palette.primary.main, ODD_OPACITY),
      '@media (hover: none)': {
        backgroundColor: 'transparent',
      },
    },
    '&.Mui-selected': {
      backgroundColor: alpha(
        theme.palette.primary.main,
        ODD_OPACITY + theme.palette.action.selectedOpacity,
      ),
      '&:hover, &.Mui-hovered': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          ODD_OPACITY +
          theme.palette.action.selectedOpacity +
          theme.palette.action.hoverOpacity,
        ),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: alpha(
            theme.palette.primary.main,
            ODD_OPACITY + theme.palette.action.selectedOpacity,
          ),
        },
      },
    },
  },
}));



const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}

function BootstrapDialogTitle(props: DialogTitleProps) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

type Anchor = 'top' | 'left' | 'bottom' | 'right';

interface IFormInput {
  Name: string
  Type: string
  Crew: string
}

const resolver: Resolver<IFormInput> = async (values) => {
  return {
    values: values.Name ? values : {},
    errors: !values.Name
      ? {
        Name: {
          type: 'required',
          message: 'This is required.',
        },
      }
      : {},
  };
};

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function ChemicalInventory() {

  function ChemicalClicked(_event: React.MouseEvent<HTMLElement>): void {
    
    setOpen(true);
  }

  function POClicked(_event: React.MouseEvent<HTMLElement>): void {
    
    handlePoOpen();
  }

  const [open, setOpen] = useState(false);

  function handleClose() {
    setOpen(!open);
  }

  let navigate = useNavigate();
  const handlePoOpen = () => {
    navigate('/po/PoOrder')
    // setPoOpen(true);
  };

  const buttons = [
    <ActionButton action={ChemicalClicked} buttonLabel="ADD NEW CHEMICAL" />,
    <ActionButton action={POClicked} buttonLabel="ADD NEW PO" />,
    
  ];

  const dispatch = useAppDispatch();

  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const [rows, setRows] = useState<IPurchaseOrderDetails>([]);
  const [poRows, setPoRows] = useState<IPurchaseOrderDetails>([]);


  useEffect(() => {
    axios
      .get('https://localhost:44324/api/Chemicals')
      .then(res => {
        setRows(res.data);
      })
      axios
      .get('https://localhost:44324/api/ChemicalPurchaseOrders')
      .then(res => {
        console.log(res.data);
        setPoRows(res.data);
      })
  }, []);

  useEffect(() => {
    let appState: IApplication = {
      pageTitle: "Chemical Inventory",
      backgroundPath: "/assets/images/growing.jpg"
    }
    dispatch(setPageTitle(appState));
  }, []);


  const { register, handleSubmit, control, formState: { errors } } = useForm<IFormInput>({ resolver });

  const onSubmit: SubmitHandler<IFormInput> = data => {
    axios.post('https://localhost:44324/api/PatchingLists', {
      name: data.Name, generation: data.Type, assignedTo: data.Crew
    }).then((data) => {
      if (data.status === 200) {
        setOpen(false);
      };
    });
  };

  
  
  const [helpOpen, setHelpOpen] = React.useState(false);
  const [poOpen, setPoOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClickHelpOpen = () => {
    setHelpOpen(true);
  };

  const handleHelpClose = () => {
    setHelpOpen(false);
  };

  

  const handlePoClose = () => {
    setPoOpen(false);
  };


  



  const columnsinventory: GridColDef[] = [
    { field: 'id', headerName: 'ID', width: 150, hide: true },
    { field: 'name', headerName: 'Name', width: 200 },
    { field: 'epaNumber', headerName: 'EPA Number', width: 200 },
    { field: 'activeIngrediant', headerName: 'Active Ingredient', width: 200, },
    { field: 'rei', headerName: 'REI', width: 200, },
    { field: 'amountOnHand', headerName: 'Amount on Hand', width: 150, },
  ];

  const columnspo: GridColDef[] = [
    //{ field: 'id', headerName: 'ID', width: 150 },
    { field: 'poNumber', headerName: 'PO Number', width: 200 },
    { field: 'name', headerName: 'Name', width: 250 },
    { field: 'epaNumber', headerName: 'EPA Number', width: 200, },
    { field: 'activeIngrediant', headerName: 'Active Ingredient', width: 250, },
    { field: 'rei', headerName: 'REI', width: 200, },
    { field: 'amountOrdered', headerName: 'Amount Ordered', width: 150, },
  ];

  interface IPatchingRow {
    name: string,
    status: string,
    patchweek: number,
    generation: string
  }

  // const rows = [
  //   { id: 1, name: 'Snow', status: 'Jon', location: 35, patching_week: 5, patching_year: 10, projected_completion: 'testing' },
  // ];

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#010101' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    border: 0,
    borderRadius: 0,
    boxShadow: "none",
  }));

  function valuetext(value: number) {
    return `${value}°C`;
  }

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0,
    },
  }));

  const darkTheme = createTheme({
    palette: {
      mode: 'dark',
      primary: {
        main: '#89B219',
      },
    },
  });

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  const handleDelete = () => {
    console.info('You clicked the delete icon.');
  };



  return (

    <div>
      <ActionMenu buttons={buttons}/>
      <Grid container spacing={0} bgcolor="#FFF" >
        <Grid item xs={12} >
          <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" >
                <Tab label="Inventory" {...a11yProps(1)} icon={<ChemicalIcon />} iconPosition="start" sx={{ fontSize: '1.5em', fontWeight: '700', letterSpacing: '0' }} />
                <Tab label="Purchase Orders" {...a11yProps(1)} icon={<POIcon />} iconPosition="start" sx={{ fontSize: '1.5em', fontWeight: '700', letterSpacing: '0' }} />
              </Tabs>
            </Box>
            <TabPanel value={value} index={0}>
              <Grid item xs={12}>
                <Item sx={{ padding: "0px" }}>
                  <div style={{ height: 'calc(100vh - 158px)', width: '100%' }}>
                    <StripedDataGrid
                      rows={rows}
                      columns={columnsinventory}
                      pageSize={20}
                      rowsPerPageOptions={[20]}
                      checkboxSelection
                      sx={{ borderColor: 'rgba(100,100,100,0.2)' }}
                      getRowClassName={(params) =>
                        params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                      }
                    />
                  </div>
                </Item>
              </Grid>
            </TabPanel>
            <TabPanel value={value} index={1}>
              <Grid item xs={12}>
                <Item sx={{ padding: "0px" }}>
                  <div style={{ height: 'calc(100vh - 158px)', width: '100%' }}>
                    <StripedDataGrid
                      rows={poRows}
                      columns={columnspo}
                      pageSize={20}
                      rowsPerPageOptions={[20]}
                      checkboxSelection
                      sx={{ borderColor: 'rgba(100,100,100,0.2)' }}
                      getRowClassName={(params) =>
                        params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                      }
                    />
                  </div>
                </Item>
              </Grid>
            </TabPanel>
          </Box>
        </Grid>

      </Grid>
      <div>
        <BootstrapDialog
          onClose={handleHelpClose}
          aria-labelledby="customized-dialog-title"
          open={helpOpen}
        >
          <BootstrapDialogTitle id="customized-dialog-title" onClose={handleHelpClose}>
            Need Support?
          </BootstrapDialogTitle>
          <DialogContent dividers>
            <Typography sx={{ mb: 3 }} variant="body2" gutterBottom>
              If you are having issues or have questions, please contact us below.
            </Typography>
            <Button size='large' fullWidth variant="contained" startIcon={<SmartphoneIcon />} sx={{ mb: 1, bgcolor: '#89B219' }}>
              <Link href="tel:8003141797" underline="none" color="#FFF"><Typography variant='h6' fontWeight={700}>800-314-1797</Typography></Link>
            </Button>
            <Button size='large' fullWidth variant="contained" startIcon={<EmailIcon />} sx={{ mb: 1, bgcolor: '#89B219' }}>
              <Link href="mailto:bobsmarket@idatp.com" underline="none">
                <Typography variant='h6' fontWeight={700} color="#FFF">support@idatp.com</Typography></Link>
            </Button>
          </DialogContent>
        </BootstrapDialog>
      </div>

      <Dialog open={open} onClose={handleClose} maxWidth='md' fullWidth>
        <DialogTitle>Add New Chemical</DialogTitle>
        <Box component="form" onSubmit={handleSubmit(onSubmit)}>
          <DialogContent>
            <Grid container spacing={0} >
              <Grid item xs={6}>
                <Item>
                  <TextField
                    required
                    variant="filled"
                    fullWidth
                    id="chemicalid"
                    label="ID"
                    {...register("Name")} />
                </Item>
              </Grid>
              <Grid item xs={6}>
                <Item>
                  <TextField
                    required
                    variant="filled"
                    fullWidth
                    id="epanumber"
                    label="EPA Number"
                    {...register("Name")} />
                </Item>
              </Grid>
              <Grid item xs={6}>
                <Item>
                  <TextField
                    required
                    variant="filled"
                    fullWidth
                    id="chemicalname"
                    label="Name"
                    {...register("Name")} />
                </Item>
              </Grid>
              <Grid item xs={6}>
                <Item>
                  <TextField
                    required
                    variant="filled"
                    fullWidth
                    id="activeingredient"
                    label="Active Ingredient"
                    {...register("Name")} />
                </Item>
              </Grid>
              <Grid item xs={6}>
                <Item>
                  <TextField
                    required
                    variant="filled"
                    fullWidth
                    id="rei"
                    label="REI"
                    {...register("Name")} />
                </Item>
              </Grid>
              <Grid item xs={6}>
                <Item>
                  <TextField
                    required
                    variant="filled"
                    fullWidth
                    id="checmicalamount"
                    label="Amount"
                    {...register("Name")} />
                </Item>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            <Button type='submit' variant="contained" color="success" onClick={() => confirmDialog("Are you sure you want to add this chemical?", handleSubmitD)}>Add Chemical</Button>
          </DialogActions>
          <ConfirmDialog />
        </Box>
      </Dialog>
    </div>
  );
}

const patchingWeeks = [
  { label: 'Week One', type: 'week_one' },
  { label: 'Week Two', type: 'week_two' },
  { label: 'Week Three', type: 'week_three' },
  { label: 'Week Four', type: 'week_four' },
];

interface IPatchingListType {
  label: string;
  type: string;
}

const patchingListTypes = [
  { label: 'Generation 1', value: 'gen_one' },
  { label: 'Generation 2', value: 'gen_two' },
  { label: 'Manual', value: 'manual' },
  { label: 'Blow Out', value: 'blow_out' },
];

const crews = [
  { label: 'Crew A', value: '1' },
  { label: 'Crew B', value: '2' },
  { label: 'Crew C', value: '3' },
  { label: 'Crew D', value: '4' },
];

const marks = [
  {
    value: 0,
    label: 'WK1',
  },
  {
    value: 5,
    label: 'WK2',
  },
  {
    value: 10,
    label: 'WK3',
  },
  {
    value: 15,
    label: 'WK4',
  },
];
